// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../../engines/gameEngine";
import utilsModel from "../../../../../engines/libs/utilsModel";

const {ccclass, property} = cc._decorator;

@ccclass
export default class MansionOperateChangeName extends BasePopUpLayer {

	@property({ type: cc.EditBox, displayName:'' })
	editBox: cc.EditBox = null;

    @property(cc.Node)
    nodeConfirm: cc.Node = null;

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        let curName = this._carryData.curName;
        if (utilsModel.isValidNumberValue(curName)) {
            this.editBox.string = curName;
        }
    }

    onClickConfirm() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        let newName = this.editBox.string;
        if (newName.trim() == '') {
            O1HD.getModules().uiControlModule.showMessageBox('名字不能为空');
            return;
        }
        
        // if (O1HD.getServices().miniGameSrv.getAppApiInstance().isContainSensitiveWord(newName)) {
        //     O1HD.getModules().uiControlModule.showMessageBox('不能包含敏感词汇');
        //     return;
        // }
        let changeName = this._carryData.changeName;
        if (changeName) {
            changeName(newName);
        }
        this.destroyNode();
    }

    onInputStart(editBox: cc.EditBox) {
        this.nodeConfirm.active = false;
    }

    async onConfirmInput(editBox: cc.EditBox) {
        if (editBox.string.trim() == '') {
            this.nodeConfirm.active = true;
            return;
        }
        let str = editBox.string;
        editBox.string = '';
        editBox.string = await O1HD.getServices().miniGameSrv.getAppApiInstance().replaceSensitiveWord(str);
        this.nodeConfirm.active = true;
    }

    async onInputReturn(editBox: cc.EditBox) {
        if (editBox.string.trim() == '') {
            this.nodeConfirm.active = true;
            return;
        }
        let str = editBox.string;
        editBox.string = '';
        editBox.string = await O1HD.getServices().miniGameSrv.getAppApiInstance().replaceSensitiveWord(str);
        this.nodeConfirm.active = true;
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.destroyNode();
    }

    // update (dt) {}
}
